import { postRequest, postBaseRequest, postCustomRequest, getCustomRequest, getRequest, getPrivateRequest, deleteRequest, getBaseRequest } from './axiosClient'
import { isDefined, replaceStringWith } from './helpers';

export const sectionCounter = (sectionID) => {
    return postRequest('counter?section_id=' + sectionID + '&brand-key=' + process.env.brand.brand_key);
};

export const resetToken = () => {
    return getBaseRequest('checkout/reset-token');
};

export const updatePrices = (data) => {
    return postRequest('cart/update-prices', data)
};

export const updateTlifStatus = (data) => {
    return postRequest('quote/update-tlif-status', data)
};

export const hireSaving = (data) => {
    const brandKey = isDefined(data?.brand) ? data.brand : process.env.brand.brand_key;
    return getRequest('quote/hire-saving?brand=' + brandKey + '&hire-days=' + data.hireDays + '&product-total=' + data.product_total);
};

export const getSurcharges = (data) => {
    //add collection_date_timestamp and delivery if they exist, if not dont
    let timestampString = '';
    if (data?.deliveryDateTimestamp && data?.collectionDateTimestamp) {
        timestampString += `&delivery-date-timestamp=${data.deliveryDateTimestamp}&collection-date-timestamp=${data.collectionDateTimestamp}`;
    }


    const brandKey = data?.brand ? data.brand : process.env.brand_key;
    return getRequest('surcharges?brand=' + brandKey + '&delivery-postcode=' + data.deliveryPostcode + '&collection-postcode=' + data.collectionPostcode + timestampString)
};

export const getMinHire = (data) => {
    const brandKey = data?.brand ? data.brand : process.env.brand_key;
    return getRequest('quote/min-hire?brand=' + brandKey + '&postcode=' + data.postcode + '&company=' + data.company)
};

export const getTransport = (data, include_doris_ids = false, isPost = false) => {
    const brandKey = data?.brand ? data.brand : process.env.brand_key;
    let product_string = "";
    // The payload data cart_products & cart_qty are passed in to calculate the transport costs (including weight and area)
    if (data?.products && data.products.length != 0) {
        for (let i = 0; i < data.products.length; i++) {
            product_string += `&cart_products[]=${data.products[i].product_id}&cart_qty[]=${data.products[i].Quantity}`;
            if (include_doris_ids) {
                product_string += `&doris_ids[]=${data.products[i].doris_id}`;
            }
        }
    }

    let timestampString = '';
    if (data?.deliveryDateTimestamp) {
        timestampString += `&delivery-date-timestamp=${data.deliveryDateTimestamp}`;
    }
    if (data?.collectionDateTimestamp) {
        timestampString += `&collection-date-timestmap=${data.collectionDateTimestamp}`;
    }
    if (data?.min_hire) {
        timestampString += `&min_hire=${data.min_hire}`;
    }
    if (isPost) {
        return postRequest('quote/transport', {
            'brand': brandKey,
            'delivery-postcode': data.deliveryPostcode,
            'collection-postcode': data.collectionPostcode,
            'cart-total-weight': data.cartTotalWeight,
            'cart_products': data.products.map(p => p.product_id),
            'cart_qty': data.products.map(p => p.Quantity),
            'doris_ids': include_doris_ids ? data.products.map(p => p.doris_id) : null,
            'min_hire': data?.min_hire || null,
            'delivery-date-timestamp': data?.deliveryDateTimestamp || null,
            'collection-date-timestamp': data?.collectionDateTimestamp || null,
        });
    }


    return getRequest('quote/transport?brand=' + brandKey + '&delivery-postcode=' + data.deliveryPostcode + '&collection-postcode=' + data.collectionPostcode + '&cart-total-weight=' + data.cartTotalWeight + product_string + timestampString)
};
export const getProduct = (slug, width, height, avoidCategoryCheck = false) => {
    let additionalStr = avoidCategoryCheck ? '&avoid-category-check=true' : '';
    return getRequest('product?brand=' + process.env.brand.brand_key + '&product-slug=' + slug + '&section-type=category&width=' + width + '&height=' + height + '&attributes=key_feature' + additionalStr);
};

export const getAlternatives = (data) => {
    return postRequest('product/get-product-alternatives', data);
}

export const fetchBlob = async (url, replace = true) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        const base64data = await convertBlobToBase64(blob);

        if (replace) {
            return replaceStringWith(base64data, 'data:image/jpeg;base64,', '');
        }
        return base64data;
    } catch (error) {
        console.error('Error fetching blob:', error);
        return null;
    }
};

export const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            resolve(reader.result);
        };
        reader.onerror = reject;
    });
};

export const incrementOrder = (webQuoteID) => {
    return postRequest('order/increment?brand=' + process.env.brand.brand_key + '&web-quote-id=' + webQuoteID);
};

export const saveOrder = (data) => {
    return postRequest('order/save', data);
};

export const finalisePayment = (data, payment_id) => {
    const objectData = Object.assign({}, data, { payment_id: payment_id });
    // console.log(objectData)
    return postBaseRequest('checkout/finalise-payment', objectData);
};

export const saveChecklistAddress = (data) => {
    return postRequest('order/save-checklist-address', data)
}

export const getCraftyResultsQuery = (data) => {
    return postCustomRequest('https://api.craftyclicks.co.uk/address/1.1/find', data);
}
export const retrieveCraftyClicksAddress = (data) => {
    return postCustomRequest('https://api.craftyclicks.co.uk/address/1.1/retrieve', data);
}

export const convertDorisToHerbertAddress = (address, quote) => {
    return {
        'postcode': address.postCode,
        'company': address.companyName,
        'address_1': address.address1,
        'address_2': address.address2,
        'town': address.town,
        'county': address.county,
        'country': address.country,
        'firstname': address.contactName,
        'email': quote.email,
        'telephone': address.telephone,
        'floor_level': address.floor,
        'lift_access': address.lift,
        'lift_big_enough': address.liftFit,
        'additional_info': address.additionalInfo,
        'parking_restrictions': address.parkingRestrictions,
        'del_col_contact_name': address.contactName,
        'del_col_contact_number': address.telephone
    }
};


export const calculateShipping = (postcode) => {
    const brand = process.env.brand.brand_key;
    return getRequest(`quote/postcode-checker?brand=${brand}&delivery-postcode=${postcode}&collection-postcode=${postcode}&cart-total-weight=0`)
}

export const checkCarriageId = (carriageId) => {
    return getRequest(`tracking/check_carriage_id?tracking_ref=${carriageId}`);
}

export const convertToDoris = (data) => {
    return postBaseRequest('dashboard/quote/convert', data)
};

export const checkStock = (data) => {
    return postRequest('quote/check-stock', data);
}

export const checkStockV2 = (data) => {
    return postBaseRequest('check-stock', data)
}

export const checkQuoteLimitations = (data) => {
    return postRequest('quote/account-limitations', data);
}

export const updateQuoteFields = (data) => {
    return postBaseRequest('agent/update-quote-details', data);
}